module.exports = "/_next/static/images/2918c44eac1690c62fba932d83886610-sanpablo-5-desktop.jpg.webp";